import { CheckCircleIcon } from "@heroicons/react/20/solid";

const benefits = [
  "Uygun fiyat garantisi",
  "Hızlı tamir süreci",
  "Orijinal yedek parçalar",
  "Uzman teknik ekip",
  "Garantili hizmet",
  "Müşteri memnuniyeti",
];

export default function Example() {
  return (
    <>
      <div className="bg-gray-900 py-24 ">
        <div className="relative isolate">
          <div className="mx-auto max-w-8xl">
            <div className="mx-auto flex max-w-2xl flex-col gap-36 px-6 py-16 lg:mx-0 lg:max-w-none lg:flex-row lg:items-center lg:justify-between lg:py-14 xl:px-20">
              {/* Sol Kısım */}
              <div className="max-w-xl flex-auto">
                <h2 className="text-4xl font-bold tracking-tight text-white sm:text-5xl">
                  Heading
                </h2>
                <p className="mt-6 text-lg leading-8 text-gray-300">
                  Lorem ipsum dolor sit amet consect adipisicing elit. Possimus
                  magnam voluptatum cupiditate veritatis in accusamus quisquam.
                  Lorem ipsum dolor sit amet consect adipisicing elit. Possimus
                  magnam voluptatum cupiditate veritatis in accusamus quisquam.
                </p>
              </div>

              {/* Görsel */}
              <div className="flex justify-center lg:justify-end">
                <img
                  alt=""
                  src="https://www.apple.com/v/iphone/home/bx/images/overview/select/iphone_16pro__erw9alves2qa_xlarge_2x.png"
                  className="h-96 w-full flex-none rounded-2xl object-contain lg:aspect-square lg:h-auto lg:max-w-sm"
                />
              </div>

              {/* Liste */}
              <ul className="mt-10 space-y-3 text-base leading-7 text-white">
                {benefits.map((benefit) => (
                  <li key={benefit} className="flex gap-x-3">
                    <CheckCircleIcon
                      aria-hidden="true"
                      className="h-7 w-5 flex-none"
                    />
                    {benefit}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Arka Plan */}
          <div
            aria-hidden="true"
            className="absolute inset-x-0 -top-16 -z-10 flex transform-gpu justify-center overflow-hidden blur-3xl"
          >
            <div
              style={{
                clipPath:
                  "polygon(73.6% 51.7%, 91.7% 11.8%, 100% 46.4%, 97.4% 82.2%, 92.5% 84.9%, 75.7% 64%, 55.3% 47.5%, 46.5% 49.4%, 45% 62.9%, 50.3% 87.2%, 21.3% 64.1%, 0.1% 100%, 5.4% 51.1%, 21.4% 63.9%, 58.9% 0.2%, 73.6% 51.7%)",
              }}
              className="aspect-[1318/752] w-[82.375rem] flex-none bg-gradient-to-r from-[#80caff] to-[#4f46e5] opacity-25"
            />
          </div>
        </div>

        <div className="bg-gray-900 p-2">
          <div className="max-w-8xl mx-auto">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="flex items-center justify-center h-28 bg-gray-800 text-white text-lg font-bold border border-white rounded-lg transition-transform duration-300 transform hover:scale-100 hover:shadow-lg hover:bg-gray-700">
                Kalıcı Veri Temizleme
              </div>
              <div className="flex items-center justify-center h-28 bg-gray-800 text-white text-lg font-bold border border-white rounded-lg transition-transform duration-300 transform hover:scale-100 hover:shadow-lg hover:bg-gray-700">
                Hızlı Ödeme
              </div>
              <div className="flex items-center justify-center h-28 bg-gray-800 text-white text-lg font-bold border border-white rounded-lg transition-transform duration-300 transform hover:scale-100 hover:shadow-lg hover:bg-gray-700">
                Ücretsiz Kargo
              </div>
              <div className="flex items-center justify-center h-28 bg-gray-800 text-white text-lg font-bold border border-white rounded-lg transition-transform duration-300 transform hover:scale-100 hover:shadow-lg hover:bg-gray-700">
                En İyi Fiyat
              </div>
            </div>
          </div>
        </div>

        <div className="bg-gray-900 p-2">
          <div className="max-w-8xl mx-auto">
            <div className="grid grid-cols-1">
              <div className="flex items-center justify-center w-full h-28 bg-gray-800 text-white text-lg font-semibold border border-white rounded-lg transition-transform duration-300 transform hover:scale-100 hover:shadow-lg hover:bg-gray-700">
                Süreç İşleyişi Hakkında Yönlendirme
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
